import { getFeatureConfig } from '@luna/feature-config';
import { t } from '@luna/i18n';

export class AccountNumberService {
    static stripLeadingZeros(accountPrefixOrNumber: string): string {
        return accountPrefixOrNumber.replace(/^0+/, '').replace(/^-+/, '');
    }

    static formatAccountPrefix(prefix: string): string {
        return getFeatureConfig((config) => config.transactions.stripLeadingZeros)
            ? `${this.stripLeadingZeros(prefix)}-`
            : `${prefix}-`;
    }

    static formatAccountNumber(accountNumber: string): string {
        return getFeatureConfig((config) => config.transactions.stripLeadingZeros)
            ? this.stripLeadingZeros(accountNumber)
            : accountNumber;
    }

    static formatBankCode(bankCode: string): string {
        const label = getFeatureConfig((config) => config.transactions.showBankCodeLabel)
            ? `${t('app.blz')}: `
            : '';
        return `/${label}${bankCode}`;
    }
}

/**
 * @returns SBBAN formatted account number
 */
export function formatBankCodeAndNumber(
    bankCode?: string | null,
    accountNumber?: string,
    prefix?: string,
): string {
    let result = '';

    if (
        prefix &&
        Number(prefix) !== 0 &&
        getFeatureConfig((config) => config.transactions.showAccountPrefix)
    ) {
        result += AccountNumberService.formatAccountPrefix(prefix);
    }

    if (accountNumber) {
        result += AccountNumberService.formatAccountNumber(accountNumber);
    }

    if (bankCode) {
        result += `/${bankCode}`;
    }

    return result;
}

export function formatBankCodeAndNumberLong(
    bankCode?: string | null,
    accountNumber?: string | null,
    prefix?: string | null,
): string {
    let result = `${t('app.accountNr')}: `;

    if (prefix && Number(prefix) !== 0) {
        result += AccountNumberService.formatAccountPrefix(prefix);
    }

    if (accountNumber) {
        result += AccountNumberService.formatAccountNumber(accountNumber);
    }

    if (bankCode) {
        result += AccountNumberService.formatBankCode(bankCode);
    }

    return result;
}

const BBAN_GROUP_REGEX = /([0-9]{8})|([0-9]{1,7})/g;
const BBAN_GROUP_SEPARATOR = '-';

export function formatBBAN(value: string, separator = BBAN_GROUP_SEPARATOR): string {
    const groups = value.match(BBAN_GROUP_REGEX);

    return groups ? groups.join(separator) : value;
}
